export * from './forgot-pwd.component';
export * from './forgot-pwd-link.component';
